var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-loading-container"},[_c('vue-loaders-ball-scale-multiple',{attrs:{"color":"#4A66FA","scale":"1"}}),_c('div',{staticClass:"tips"},[_vm._v("加载中...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }